import { CREATEPAYMENT, DELETEPAYMENT, GETPAYMENT, UPDATEPAYMENT } from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEPAYMENT:
            return {
                ...state,
                paymentSaveStatus: action.payload.success,
            }
        case GETPAYMENT:
                return {
                        ...state,
                        paymentList: action.payload.data,
                        }
        case UPDATEPAYMENT:
                return {
                        ...state,
                        paymentUpdateStatus: action.payload.success,
                        }   

        case DELETEPAYMENT:
                 return {
                     ...state,
                     paymentDeleteStatus: action.payload.success,
                        } 
                        default:
                            return state
                             }
                         }